import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-canal-venda-input-group',
    templateUrl: './canal-venda-input-group.component.html',
    styleUrls: ['./canal-venda-input-group.component.less']
})
export class CanalVendaInputGroupComponent {
    /** Canal de Venda */
    @Input() canalVenda: {
        id: number;
        nome: string;
        descricao: string;
        logoMiniURL: string;
    }
}
